import {Button, Modal, ModalContent, ModalFooter, ModalTitle} from '@hm/fundamental'

import {useTranslation} from '../../../../hooks/useTranslation'
import {MessageHistory} from '../../MessageHistory/MessageHistory'

type UserMessagesDialogProps = {
  open: boolean
  setOpenModal: (open: boolean) => void
  userId: string
}
export const UserMessagesDialog = ({open, setOpenModal, userId}: UserMessagesDialogProps) => {
  const {t} = useTranslation()

  return (
    <Modal open={open} onClose={() => setOpenModal(false)}>
      <ModalTitle>{t('userInformationForm.messagesHistory')}</ModalTitle>
      <ModalContent>
        <MessageHistory userId={userId} />
      </ModalContent>
      <ModalFooter>
        <Button size="large" variant="secondary" onClick={() => setOpenModal(false)}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}
